import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IEstimateLayout, IEstimateTemplate, IEstimateTemplateAuthorization, IEstimateTemplateIntroduction } from '~/utils/interface/estimateSetting';
import { handleGetEstimateLayouts, handleGetEstimateTemplateAuthorization, handleGetEstimateTemplateIntroduction, handleGetEstimateTemplates } from './estimateSettingThunk';

export interface EstimateSettingState {
  estimateLayouts: IEstimateLayout[],
  needRefreshData: boolean,
  estimateTemplates: IEstimateTemplate[],
  needRefreshDataEstimateTemplates: boolean,
  estimateTemplateIntroduction: IEstimateTemplateIntroduction[],
  needRefreshDataEstimateTemplateIntroduction: boolean,
  estimateTemplateAuthorization: IEstimateTemplateAuthorization[],
  needRefreshDataEstimateTemplateAuthorization: boolean,
}

const initialState: EstimateSettingState = {
  estimateLayouts: [],
  needRefreshData: false,
  estimateTemplates: [],
  needRefreshDataEstimateTemplates: false,
  estimateTemplateIntroduction: [],
  needRefreshDataEstimateTemplateIntroduction: false,
  estimateTemplateAuthorization: [],
  needRefreshDataEstimateTemplateAuthorization: false,
};

const estimateSettingSlice = createSlice({
  name: 'estimateSetting',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    changeNeedRefreshDataEstimateTemplates(state, action: PayloadAction<boolean>) {
      state.needRefreshDataEstimateTemplates = action.payload;
    },
    changeNeedRefreshDataEstimateTemplateIntroduction(state, action: PayloadAction<boolean>) {
      state.needRefreshDataEstimateTemplateIntroduction = action.payload;
    },
    changeNeedRefreshDataEstimateTemplateAuthorization(state, action: PayloadAction<boolean>) {
      state.needRefreshDataEstimateTemplateAuthorization = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetEstimateLayouts.fulfilled, (state, action) => {
        state.estimateLayouts = [...action.payload.responses];
        state.needRefreshData = false;
      })
      .addCase(handleGetEstimateTemplates.fulfilled, (state, action) => {
        state.estimateTemplates = [...action.payload.responses];
        state.needRefreshDataEstimateTemplates = false;
      })
      .addCase(handleGetEstimateTemplateIntroduction.fulfilled, (state, action) => {
        state.estimateTemplateIntroduction = [...action.payload.responses];
        state.needRefreshDataEstimateTemplateIntroduction = false;
      })
      .addCase(handleGetEstimateTemplateAuthorization.fulfilled, (state, action) => {
        state.estimateTemplateAuthorization = [...action.payload.responses];
        state.needRefreshDataEstimateTemplateAuthorization = false;
      })
  },
});

export const estimateSettingActions = estimateSettingSlice.actions;

const estimateSettingReducer = estimateSettingSlice.reducer;
export default estimateSettingReducer;
